import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

const PROJECTS = [
  { tag: "Bioacoustics", title: "Listening to Forests", text: "Open models that translate forest soundscapes into health indicators.", region: "Brazil · Kenya" },
  { tag: "Healing Tech", title: "Vagal Signal Studio", text: "Wearable + AI feedback for nervous system regulation in clinical settings.", region: "Finland" },
  { tag: "Language", title: "Indigenous Language Archive", text: "Community-owned model training for endangered languages.", region: "Andes · Pacific" },
  { tag: "Education", title: "Wisdom Tutor", text: "An AI companion that learns from elders and teaches with humility.", region: "Global" },
  { tag: "Climate", title: "Soil Memory", text: "Hyperlocal soil-health prediction for smallholder farmers.", region: "West Africa" },
  { tag: "Governance", title: "Open Council OS", text: "Tooling for civic assemblies to deliberate with AI assistance, transparently.", region: "EU · India" },
];

export default function WorldAI() {
  return (
    <div data-testid="page-world-ai">
      <section className="relative">
        <div className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: "url(https://images.pexels.com/photos/7248774/pexels-photo-7248774.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940)" }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-white/80" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-28 lg:py-40">
          <p className="overline">World AI Innovation Center</p>
          <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-7xl font-light tracking-tight text-ink max-w-5xl">
            Inventors and projects, gathered into one global stage.
          </h1>
          <p className="mt-8 max-w-2xl text-lg text-ink/70 leading-relaxed">
            We connect AI inventors with mentorship, compute, and a worldwide
            audience. Our cohorts focus on healing, ecology, language, and
            governance — the fields where AI most needs wisdom.
          </p>
          <div className="mt-10">
            <Link to="/contact" className="btn-ink rounded-full px-6 py-3 text-sm font-medium inline-flex items-center gap-2" data-testid="world-cta-apply">
              Apply to the next cohort <ArrowUpRight size={16} weight="bold" />
            </Link>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <p className="overline">Inaugural Cohort</p>
            <h2 className="mt-3 font-display text-3xl lg:text-5xl font-light tracking-tight text-ink">
              Six projects we’re backing.
            </h2>
          </div>
          <p className="lg:col-span-6 lg:col-start-7 text-lg text-ink/70 leading-relaxed">
            Each project sits at the intersection of AI and a deeply human
            concern — language, soil, healing, governance. Selection prioritizes
            community ownership and transparency.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="world-projects">
          {PROJECTS.map((p) => (
            <div key={p.title} className="bg-white rounded-2xl p-7 ring-1 ring-ink/10 card-shadow hover:-translate-y-1 transition-transform">
              <div className="flex items-center justify-between">
                <span className="text-[10px] tracking-widest uppercase px-2.5 py-1 rounded bg-gold/15 text-earth font-semibold">{p.tag}</span>
                <span className="text-xs text-ink/40">{p.region}</span>
              </div>
              <h3 className="mt-6 font-display text-2xl text-ink leading-snug">{p.title}</h3>
              <p className="mt-3 text-ink/65 leading-relaxed">{p.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
